import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-banner',
    standalone: true,
    imports: [NgClass, MatIconModule, MatButtonModule],
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss',
})
export class BannerComponent {
    @Input() bannerMessage: string = '';
    @Input() displayMaxItemsAlert: boolean = false;
    @Input() displayCloseButton: boolean = true;
    @Input() type: 'info' = 'info';
    @Input() showIconType: boolean = true;
    @Input() bannerTitle: string;
    @Input() customClass: boolean = false;

    closeBanner(): void {
        this.displayMaxItemsAlert = false;
    }
}
